import { useRates } from "@/context/RateContext";
import { useEffect, useState } from "react";
import { Radio } from "lucide-react";

function fmt(n) {
  return Number(n ?? 0).toLocaleString("tr-TR", { minimumFractionDigits: 4, maximumFractionDigits: 4 });
}

function unitOf(rate, defaultUnit = "₺") {
  return rate?.unit || defaultUnit;
}

function RateCell({ metal, label, rate, flash, defaultUnit }) {
  const [flashClass, setFlashClass] = useState("");
  useEffect(() => {
    if (!flash) return;
    setFlashClass(flash.dir === "up" ? "flash-up" : "flash-down");
    const t = setTimeout(() => setFlashClass(""), 900);
    return () => clearTimeout(t);
  }, [flash?.at]);

  const isLive = rate?.source === "haremaltin" || rate?.source === "truncgil";
  const unit = unitOf(rate, defaultUnit);

  return (
    <div className="flex items-baseline gap-3 px-5 py-3 border-r border-white/5 min-w-[240px]" data-testid={`ticker-${metal}`}>
      <span className="label-caps">{label}</span>
      <div className="flex flex-col">
        <span className={`font-mono text-lg tabular-nums text-white ${flashClass}`} data-testid={`ticker-${metal}-sell`}>
          {rate ? `${fmt(rate.selling_price)} ${unit}` : "—"}
        </span>
        <span className="font-mono text-[10px] text-neutral-500 tabular-nums flex items-center gap-2">
          Alış {rate ? `${fmt(rate.buying_price)} ${unit}` : "—"}
          {isLive && <span className="text-emerald-500" title="Canlı Kapalıçarşı verisi">●</span>}
        </span>
      </div>
    </div>
  );
}

export default function RateTicker() {
  const { rates, lastFlash } = useRates();
  const src = rates.gold?.source || rates.silver?.source;
  const label = src === "haremaltin" ? "Canlı · Harem Altın"
              : src === "truncgil" ? "Canlı · Truncgil"
              : "Simülasyon";
  const isLive = !!src;
  return (
    <div className="flex overflow-x-auto card-flat pl-14 lg:pl-0" data-testid="rate-ticker">
      <RateCell metal="gold" label="Has Altın · Gram" rate={rates.gold} flash={lastFlash.gold} defaultUnit="₺" />
      <RateCell metal="silver" label="Gümüş · Gram" rate={rates.silver} flash={lastFlash.silver} defaultUnit="₺" />
      <RateCell metal="platinum" label="Platin · Ons" rate={rates.platinum} flash={lastFlash.platinum} defaultUnit="$/oz" />
      <div className="flex items-center gap-2 px-5 py-3 label-caps whitespace-nowrap">
        <Radio size={12} className={isLive ? "text-emerald-400" : "text-neutral-500"} />
        {label}
      </div>
    </div>
  );
}
